<template>
<svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.99956 11.4919L25.9414 11.4919" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.4495 2L25.9414 11.4919L16.4495 20.9839" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
